import React from 'react';
import CipherAvatar from './cipher_avatar';
import { careProviderConfiguration } from 'store';
import { useAtom } from 'jotai';

const Avatar = () => {
  const [careProviderStyles] = useAtom(careProviderConfiguration);

  return careProviderStyles.botAvatar !== 'cipherAvatar'
    ? (
        <div
          style={{
            width: '45px',
            height: '45px',
            background: careProviderStyles.avatarFillColor,
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          data-cy="whitelabel-avatar-bg"
        >
          <img
            style={{ maxWidth: '30px' }}
            src={careProviderStyles.botAvatar}
            data-cy="whitelabel-avatar-img"
          />
        </div>
      )
    : (
        <CipherAvatar />
      );
};

export default Avatar;
